import React from "react"
import PropTypes from "prop-types"

import MeetingListItem from './MeetingListItem';

export function SparkleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="url(#upcomingLexSparkleGradient)"
        d="M12 2l1.8 5.4L19 9.2l-5.2 1.8L12 16.4l-1.8-5.4L5 9.2l5.2-1.8L12 2zm7 10l1.1 3.3L23 16.4l-2.9 1.1L19 20.8l-1.1-3.3L15 16.4l2.9-1.1L19 12z"
      />
      <defs>
        <linearGradient id="upcomingLexSparkleGradient" x1="5" y1="2" x2="23" y2="21" gradientUnits="userSpaceOnUse">
          <stop stopColor="#494CE9" />
          <stop offset="1" stopColor="#03A9F4" />
        </linearGradient>
      </defs>
    </svg>
  )
}

class UpcomingMeetingsContainer extends React.Component {

  constructor(props) {
    super(props)

    this.renderMeetings = this.renderMeetings.bind(this)
  }

  renderMeetings() {
    if(this.props.meetings.length > 0) {
      return this.props.meetings.map((meeting, i) => {
        return(
          <MeetingListItem
              key={meeting.id || i}
              item={meeting}
              currentUser={this.props.currentUser}
              getAllMeetings={this.props.getAllMeetings}
            />
        )
      })
    } else {
      return(
        <div className="upcomingLexesSection__empty">
          <p className="sectionText">No upcoming meetings.</p>
          <p className="sectionText">Connect, chat, then schedule a Lex.</p>
          <div className="noMeetingImage"></div>
        </div>
      )
    }
  }

  render() {
    return(
      <section className="upcomingLexesSection">
        <header className="upcomingLexesSection__header">
          <div className="upcomingLexesSection__titleRow">
            <span className="upcomingLexesSection__iconCircle" aria-hidden="true">
              <SparkleIcon />
            </span>
            <h2 className="upcomingLexesSection__title">Upcoming Lexes</h2>
          </div>
        </header>
        {this.renderMeetings()}
      </section>
    )
  }

}

export default UpcomingMeetingsContainer;
